<template>
  <div>
    <div>
      <el-card class="btn-card">
        <h2>Outbound shipping</h2>
        <el-button class="btn-send" @click='back'>back</el-button>
        <div class="form-box">
          <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="Dealer ID" prop="autelId">
              <el-input v-model="form.autelId" @input="getAutelInfo"></el-input>
            </el-form-item>
            <el-form-item label="Dealer name" prop="autelName">
              <el-input v-model="form.autelName" disabled></el-input>
            </el-form-item>
            <el-form-item label="Dealer email" prop="auteleMail">
              <el-input v-model="form.auteleMail" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <div class="table-box">
        <el-table
        v-loading="loading"
        :data="tableData"
        :header-cell-style="{ 'text-align': 'center', color: '#000000', background: '#FAFAFA' }"
        :cell-style="{ 'text-align': 'center' }"
        stripe
        >
        <el-table-column
            prop="upgradeCardType"
            label="TCP types"
        >
        </el-table-column>
        <el-table-column
            label="Shipment quantity"
        >
        <template slot-scope="scope">
          <el-input v-model="scope.row.deliveryNum" style="width:200px;" @blur="getValue(scope.row.deliveryNum,scope.row.currentStorage,scope.$index)"></el-input>
        </template>
        </el-table-column>
        <el-table-column
            prop="currentStorage"
            label="Inventory"
        >
        </el-table-column>
        </el-table>
      </div>
      <div class="btn-download">
        <el-button type="primary" :loading="btnLoading"  @click='sbumit'>Download</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getList,
  getAutelInfo,
  sendDelivery
} from '@/api/virtual-card.js'

export default {
  data () {
    const checkEmail = (rule, value, callback) => {
      // 验证邮箱的正则
      const regEmail =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
      if (regEmail.test(value)) {
        // 合法邮箱
        return callback()
      }
      callback(new Error('Please fill in correct email'))
    }
    return {
      timer: null,
      loading: false,
      btnLoading: false,
      tableData: [],
      form: {
        autelId: '',
        autelName: '',
        auteleMail: ''
      },
      rules: {
        autelId: [
          { required: true, message: 'Dealer ID cannot be empty', trigger: 'blur' }
        ],
        autelName: [
          { required: true, message: 'Dealer name cannot be empty', trigger: 'blur' }
        ],
        auteleMail: [
          { required: true, message: 'Dealer email cannot be empty', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    totalNumbers () {
      let total = 0
      this.tableData.forEach(item => {
        total += item.currentStorage
      })
      return total
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getAutelInfo () {
      const autelId = this.form.autelId
      if (!autelId) return
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        getAutelInfo({
          autelId
        }).then(res => {
          if (res.code === 'S0000') {
            this.form.autelName = res.data ? res.data.name : ''
            this.form.auteleMail = res.data ? res.data.email : ''
          }
        })
      }, 800)
    },
    sbumit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const sendFlag = this.tableData.every(item => {
            return !item.deliveryNum
          })
          if (sendFlag) {
            this.$message.warning('Please fill in shipment quantity')
            return
          }
          const dealerStorageList = this.tableData.filter(item => {
            return item.deliveryNum
          })
          let deliveryNums = 0
          dealerStorageList.forEach(item => {
            deliveryNums += Number(item.deliveryNum)
          })
          if (deliveryNums > 1000) {
            this.$message.warning('Hi, over 1000 Autel E-TCP cards is downloaded this time. Please adjust the quantity and download again. Thank you!')
            return
          }
          this.btnLoading = true
          sendDelivery({
            ...this.form,
            dealerStorageList
          }).then(res => {
          })
            .catch((res) => {
              console.log(res)
              const url = window.URL.createObjectURL(new Blob([res.data]))
              // 生成一个a标签
              const link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              // 生成时间戳
              const timestamp = new Date().getTime()
              link.download = `${this.form.autelId}_${this.form.autelName}_${timestamp}.zip`
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              this.$message.success('success')
              this.back()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    getValue (deliveryNum, currentStorage, index) {
      const reg = /^[-+]?\d*$/
      if (deliveryNum && (deliveryNum <= 0 || !reg.test(deliveryNum))) {
        this.$message.error('Please fill in positive integer')
        this.tableData[index].deliveryNum = 0
        return
      }
      if (deliveryNum > currentStorage) {
        this.$message.error('Inventory shortage')
        this.tableData[index].deliveryNum = 0
      }
    },
    back () {
      this.$router.back()
    },
    // 获取列表
    getList () {
      this.loading = true
      getList().then(res => {
        res.data.forEach(item => {
          item.deliveryNum = 0
        })
        this.tableData = res.data
      })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-card {
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  h2{
      text-align: center;
      span{
          color: #409eff;
      }
  }
  .btn-send{
      position: absolute;
      right: 20px;
      top: 20px;
  }
  .form-box{
    width: 500px;
    margin: 0 auto;
  }
}
.btn-download{
  margin-top: 20px;
  text-align: center;
}
</style>
